export function shouldUseUnsponsoredNadoTransaction({
  canSponsor,
  inkGasBalance,
}: {
  canSponsor: boolean;
  inkGasBalance: bigint | undefined;
}): boolean {
  if (canSponsor) {
    return false;
  }

  return inkGasBalance !== undefined && inkGasBalance > BigInt("0");
}

export function assertCanSubmitNadoTransaction({
  canSponsor,
  inkGasBalance,
}: {
  canSponsor: boolean;
  inkGasBalance: bigint | undefined;
}): void {
  if (canSponsor || shouldUseUnsponsoredNadoTransaction({ canSponsor, inkGasBalance })) {
    return;
  }

  throw new Error('Privy sponsored deposit is not available and this wallet has no ETH on Ink for gas');
}
